import { ProductCreatePage } from "./ProductCreatePage";

export function ProductionProductCreatePage() {
  return <ProductCreatePage catalogMode="production" />;
}
